<template>
  <div>
    <app-section-loader :status="fileloader"></app-section-loader>
    <v-data-table
      :items="taskItems"
      class="elevation-1"
      :headers="headers"
      hide-actions
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td
            class="px-1"
            style="width: 0.1%"
          >
            <v-btn icon>
              <v-icon>attach_file</v-icon>
            </v-btn>
          </td>
          <td>{{ props.item.fileName }}</td>
          <td>{{ props.item.fileSize }}</td>
          <!-- <td>{{ props.item.displayName }}</td> -->
          <td>
            <v-icon
              class="mr-2"
              small
            >done</v-icon>
          </td>
          <td>
            <v-icon
              class="mr-2"
              small
            >done</v-icon>
          </td>
          <td></td>
          <td class="text-xs-right">{{ props.item.uploadDate | formatDate}}</td>
          <td class="text-xs-right">{{ props.item.addedByUser | formatDate}}</td>
          <!-- <td>
            <v-icon
              small
              class="mr-2"
              @click="download(props.item)"
            >
              cloud_download
            </v-icon>

          </td> -->

          <td>
            <v-spacer></v-spacer>
            <v-menu
              bottom
              right=""
            >
              <v-btn
                slot="activator"
                icon
              >
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in items"
                  :key="i"
                  @click="menuClick(i,props.item)"
                  ripple="ripple"
                  :disabled="item.disabled"
                  :target="item.target"
                  rel="noopener"
                >
                  <v-list-tile-action v-if="item.icon">
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>

          </td>
        </tr>
      </template>
    </v-data-table>

    <!-- <v-navigation-drawer
      class="setting-drawer"
      temporary
      right
      v-model="setAccessDialouge"
      hide-overlay
      fixed
      :width="500"
    >
      <template>
        <div id="themeSetting">
          <v-toolbar
            color="primary"
            dark
          >
            <v-toolbar-title>
              Document Access
            </v-toolbar-title>
          </v-toolbar>
          <v-card>
            <v-form
              v-model="formdata.valid"
              ref="form"
              lazy-validation
            >
              <v-card-title>
                <span>Set Access</span>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                <v-autocomplete
                  :loading="fileloader"
                  flat
                  chips
                  multiple
                  label="User"
                  prepend-icon="persion"
                  v-model="formdata.assignedCC"
                  :items="cCItems"
                  item-text="userName"
                  item-value="userID"
                >
                </v-autocomplete>
                <v-checkbox
                  primary
                  label="IS Special File"
                  v-model="formdata.isSpecialFile"
                ></v-checkbox>

                <v-autocomplete
                  :loading="fileloader"
                  flat
                  chips
                  multiple
                  label="User"
                  prepend-icon="persion"
                  v-model="formdata.assignedCC"
                  :items="cCItems"
                  item-text="userName"
                  item-value="userID"
                >
                </v-autocomplete>
                <upload-btn
                  :fileChangedCallback="fileChanged"
                  title="Upload your document"
                  name="uploadtask"
                  uniqueId
                >
                  <template slot="icon-left">
                    <v-icon
                      left
                      color="white"
                    >attachment</v-icon>
                  </template>
                </upload-btn>
                <div class="large-12 medium-12 small-12 cell">
                  <div
                    v-for="(file, key) in uploadedFiles"
                    class="file-listing"
                  >{{ file.name }}
                    <v-btn
                      icon
                      v-if="!showdownload"
                      @click="removeFile( key )"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      v-if="showdownload"
                      @click="downloadFile( key )"
                    >
                      <v-icon>save_alt</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>

                <v-btn
                  outline
                  color="primary"
                  @click.native="save"
                >Set Access</v-btn>
                <v-btn
                  outline
                  color="primary"
                  @click="setAccessDialouge = false"
                >Close</v-btn>

              </v-card-actions>
            </v-form>
          </v-card>
        </div>
      </template>
    </v-navigation-drawer> -->
     <v-dialog
      v-model="setAccessDialouge"
      max-width="700px"
      scrollable
    >
      <v-card>
        
        <v-form
          v-model="formdata.valid"
          ref="form"
          lazy-validation
        >
        <v-toolbar
            color="primary"
            dark
          >
            <v-toolbar-title>
              Document Access
            </v-toolbar-title>
          </v-toolbar>
          <!-- <v-card-title>
            <span>File Upload</span>
            <v-spacer></v-spacer>
          </v-card-title> -->
          <v-card-text>
            <v-autocomplete
              hint="Atleast 3 Characters required"              
              chips
              multiple
              label="User"
              prepend-icon="persion"
              v-model="taskAccessPermission.assignedCc"
              :items="cCItems"
              item-text="name"
              item-value="userID"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeCC(data.item)"
                >
                  <v-avatar
                    class="primary white--text"
                    v-text="data.item.userName.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item.nickName }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
            <v-checkbox
              primary
              label="IS Special File"
              v-model="formdata.isSpecialFile"
            ></v-checkbox>
            <v-autocomplete
              hint="Atleast 3 Characters required"
              flat
              chips
              multiple
              label="User"
              prepend-icon="persion"
              v-model="taskAccessPermission.assignedCc"
              :items="cCItems"
              item-text="name"
              item-value="userID"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeCC(data.item)"
                >
                  <v-avatar
                    class="primary white--text"
                    v-text="data.item.userName.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item.nickName }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
            <upload-btn
              :fileChangedCallback="fileChanged"
              title="Upload your document"
              name="uploadtask"
              uniqueId
            >
              <template slot="icon-left">
                <v-icon
                  left
                  color="white"
                >attachment</v-icon>
              </template>
            </upload-btn>
            <div class="large-12 medium-12 small-12 cell">
              <div
                v-for="(file, key) in uploadedFiles"
                class="file-listing"
              >{{ file.name }}
                <v-btn
                  icon
                  v-if="!showdownload"
                  @click="removeFile( key )"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <v-btn
                  icon
                  v-if="showdownload"
                  @click="downloadFile( key )"
                >
                  <v-icon>save_alt</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

                 <v-btn
                  outline
                  color="primary"
                  @click.native="save"
                >Set Access</v-btn>
                <v-btn
                  outline
                  color="primary"
                  @click="setAccessDialouge = false"
                >Close</v-btn>

          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="rightDrawer"
      fullscreen
    >
      <template>
        <div id="themeSetting">
          <v-toolbar
            color="primary"
            dark
          >
            <v-toolbar-title>
              Document Conversation
            </v-toolbar-title>
            <v-spacer> </v-spacer>
            <v-btn
              icon
              @click.native="rightDrawer = false"
            >
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-toolbar>
          <vue-perfect-scrollbar
            class="chat-room--scrollbar grey lighten-5"
            v-bind:style="computeHeight"
          >
            <v-card class="chat-room">

              <v-card-text class="chat-room--list pa-3">
                <app-section-loader :status="commentloader"></app-section-loader>
                <v-list three-line>
                  <v-list-group
                    v-for="(item,mainkey) in taskComments"
                    :key="mainkey"
                    no-action
                    append-icon=""
                  >
                    <v-list-tile
                      slot="activator"
                      :key="mainkey"
                    >

                      <v-avatar class="primary mx-1 white--text">{{ item.addedByUser.slice(0, 2).toUpperCase() }}</v-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title>{{item.addedByUser}}</v-list-tile-title>

                        <v-list-tile-sub-title>
                          <span v-if="item.isEdited">
                            <v-icon small>edit </v-icon>
                          </span>
                          {{ item.comment}} </v-list-tile-sub-title>

                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-menu
                          bottom
                          left
                        >
                          <v-btn
                            slot="activator"
                            icon
                          >
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                          <v-list>
                            <v-list-tile
                              v-for="(menuitem,index) in conversationitems"
                              :to="!menuitem.href ? { name: menuitem.name } : null"
                              :href="menuitem.href"
                              @click="maincomment(index, item,item)"
                              ripple="ripple"
                              :disabled="item.commentedBy != userId"
                              :target="menuitem.target"
                              rel="noopener"
                              :key="index"
                            >
                              <v-list-tile-action v-if="menuitem.icon">
                                <v-icon>{{ menuitem.icon }}</v-icon>
                              </v-list-tile-action>
                              <v-list-tile-title>{{ menuitem.title }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-list-tile-action>

                    </v-list-tile>

                    <v-list-tile
                      v-for="(subItem,subindex) in item.taskCommentModels"
                      :key="subindex"
                    >
                      <v-avatar class="primary mx-1 white--text">{{ subItem.addedByUser.slice(0, 2).toUpperCase() }}</v-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title>{{subItem.addedByUser}}</v-list-tile-title>

                        <v-list-tile-sub-title>
                          <span v-if="subItem.isEdited">
                            <v-icon small>edit </v-icon>
                          </span> {{ subItem.comment}} </v-list-tile-sub-title>

                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-menu
                          bottom
                          left
                        >
                          <v-btn
                            slot="activator"
                            icon
                          >
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                          <v-list>
                            <v-list-tile
                              v-for="(menuitem,index) in conversationitems"
                              :to="!menuitem.href ? { name: menuitem.name } : null"
                              :href="menuitem.href"
                              @click="maincomment(index, subItem,item)"
                              ripple="ripple"
                              :disabled="subItem.commentedBy != userId"
                              :target="menuitem.target"
                              rel="noopener"
                              :key="index"
                            >
                              <v-list-tile-action v-if="menuitem.icon">
                                <v-icon>{{ menuitem.icon }}</v-icon>
                              </v-list-tile-action>
                              <v-list-tile-title>{{ menuitem.title }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-text-field
                      full-width
                      flat
                      solo
                      clearable
                      v-model="subcomment.comment"
                      label="Type some message here"
                    >
                      <template slot="append">
                        <v-icon
                          @click="sendFileSubComment(item)"
                          v-hotkey="sendsubKey"
                        >send</v-icon>
                        <!-- <v-icon @click="">attach_file</v-icon> -->
                      </template>
                    </v-text-field>

                  </v-list-group>
                </v-list>

              </v-card-text>

              <v-card-actions>
                <v-text-field
                  full-width
                  flat
                  solo
                  v-model="taskcomment.comment"
                  label="Type some message here  "
                >
                  <template slot="append">
                    <v-icon
                      @click="sendFileComment"
                      v-hotkey="sendKey"
                    >send</v-icon>
                  </template>
                </v-text-field>

              </v-card-actions>
            </v-card>
          </vue-perfect-scrollbar>
        </div>
      </template>

    </v-dialog>
     <v-dialog
      v-model="MeetingNotesDrawer"
      fullscreen
    >
      <template>
        <div id="themeSetting">
          <v-toolbar
            color="primary"
            dark
          >
            <v-toolbar-title>
              Meeting Notes
            </v-toolbar-title>
            <v-spacer> </v-spacer>
            <v-btn
              icon
              @click.native="MeetingNotesDrawer = false"
            >
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-toolbar>
          <vue-perfect-scrollbar
            class="chat-room--scrollbar grey lighten-5"
            v-bind:style="computeHeight"
          >
            <v-card class="chat-room">

              <v-card-text class="chat-room--list pa-3">
                <app-section-loader :status="meetingNotesLoader"></app-section-loader>
                <v-list three-line>
                  <v-list-group
                    v-for="(item,mainkey) in taskMeetingNote"
                    :key="mainkey"
                    no-action
                    append-icon=""
                  >
                    <v-list-tile
                      slot="activator"
                      :key="mainkey"
                    >

                      <v-avatar class="primary mx-1 white--text">{{ item.addedByUser.slice(0, 2).toUpperCase() }}</v-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title>{{item.addedByUser}}</v-list-tile-title>

                        <v-list-tile-sub-title v-html="item.meetingNotes">
                           <span v-if="item.isEdited">
                            <v-icon small>edit </v-icon>
                          </span> 
                           </v-list-tile-sub-title>

                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-menu
                          bottom
                          left
                        >
                          <v-btn
                            slot="activator"
                            icon
                          >
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                          <v-list>
                            <v-list-tile
                              v-for="(menuitem,index) in meetingitems"
                              :to="!menuitem.href ? { name: menuitem.name } : null"
                              :href="menuitem.href"
                              @click="maincomment(index, item,item)"
                              ripple="ripple"
                              :disabled="item.addedByUserID != userId"
                              :target="menuitem.target"
                              rel="noopener"
                              :key="index"
                            >
                              <v-list-tile-action v-if="menuitem.icon">
                                <v-icon>{{ menuitem.icon }}</v-icon>
                              </v-list-tile-action>
                              <v-list-tile-title>{{ menuitem.title }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-list-tile-action>

                    </v-list-tile>

                    <!-- <v-list-tile
                      v-for="(subItem,subindex) in item.taskCommentModels"
                      :key="subindex"
                    >
                      <v-avatar class="primary mx-1 white--text">{{ subItem.addedByUser.slice(0, 2).toUpperCase() }}</v-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title>{{subItem.addedByUser}}</v-list-tile-title>

                        <v-list-tile-sub-title>
                          <span v-if="subItem.isEdited">
                            <v-icon small>edit </v-icon>
                          </span> {{ subItem.comment}} </v-list-tile-sub-title>

                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-menu
                          bottom
                          left
                        >
                          <v-btn
                            slot="activator"
                            icon
                          >
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                          <v-list>
                            <v-list-tile
                              v-for="(menuitem,index) in conversationitems"
                              :to="!menuitem.href ? { name: menuitem.name } : null"
                              :href="menuitem.href"
                              @click="maincomment(index, subItem,item)"
                              ripple="ripple"
                              :disabled="subItem.commentedBy != userId"
                              :target="menuitem.target"
                              rel="noopener"
                              :key="index"
                            >
                              <v-list-tile-action v-if="menuitem.icon">
                                <v-icon>{{ menuitem.icon }}</v-icon>
                              </v-list-tile-action>
                              <v-list-tile-title>{{ menuitem.title }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-list-tile-action>
                    </v-list-tile> -->

                   

                  </v-list-group>
                </v-list>

              </v-card-text>

              <v-card-actions>
                        <v-flex
          lg11
          sm11
        > 
          <!-- <v-textarea
            prepend-icon="note_add"
            v-model="formdata.description"
            label="Description"
          >
          </v-textarea> -->
          <p>Meeting Notes</p>
          <!-- <quill-editor
            class="quill"
            :content="formdata.description"
            :options="editorOption"
            v-model="formdata.description"
            aria-placeholder="Main task Content here..."
          >
          </quill-editor> -->

          <!-- <quill-editor
            class="editor-example bubble"
            ref="myTextEditor"
            :content="formdata.description"
            :options="editorOption"
            @change="onEditorChange($event)"
          >
          </quill-editor> -->

          <editor
            v-model="taskMeeting.meetingNotes"
            :options="editorOptions"
            :html="editorHtml"
            :visible="editorVisible"
            previewStyle="vertical"
            height="300px"
            mode="wysiwyg"
          />
          </v-flex> 
           <v-flex
          lg1
          sm1
            > 
          
                    <v-icon
                      @click="sendMeetingNotes"
                      v-hotkey="sendNotesKey"
                    >send</v-icon>
                  
         </v-flex> 
                <!-- <v-text-field
                  full-width
                  flat
                  solo
                  v-model="taskcomment.comment"
                  label="Type some message here  "
                >
                  
                </v-text-field> -->

              </v-card-actions>
            </v-card>
          </vue-perfect-scrollbar>
        </div>
      </template>

    </v-dialog>
    <v-dialog
      v-model="subdialog"
      max-width="800px"
    >

      <v-card>
        <!-- <v-toolbar
            card
            dense
            color="transparent"
          >
            <v-btn
              icon
              @click.native="close"
            >
              <v-icon>reply</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="saveAndClose"
            >
              <v-icon>library_add</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="save"
            >
              <v-icon>save</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="add"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="deleterow"
            >
              <v-icon>delete</v-icon>
            </v-btn>

          </v-toolbar> -->
        <v-card-title>
          <span class="headline">{{formdata.formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <sub-task ref="refsubTaskForm"></sub-task>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            outline
            @click="subdialog = false"
          >Cancel</v-btn>
          <v-btn
            color="primary darken-1"
            outline
            @click.native="save"
          >Save</v-btn>
        </v-card-actions>
        <!-- <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog> -->
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import Bytes from 'bytes';
import SubTask from '@/pages/task/taskfromMessage';

import UploadButton from 'vuetify-upload-button';
import { downloadFile, deleteDocuments, documentUsers, uploadDocuments} from '@/api/document';
import 'tui-editor/dist/tui-editor.css';
import 'tui-editor/dist/tui-editor-contents.css';
import 'codemirror/lib/codemirror.css';
import Editor from '@toast-ui/vue-editor/src/editor.vue';
import { getTaskFiles, getDocComment, getUsers, createTaskMaster, getTaskComments,getTaskMeetingNote, getTaskAttachment, getApplicationUsers, createTaskComments, updateTaskComment, deleteTaskComment,updateTaskMeetingNote,createTaskMeetingNote } from '@/api/taskMaster';
import GlobalMessage from '@/constant'

export default {
  components: {
    'upload-btn': UploadButton,
    SubTask,
    Editor
  },
  props: {
    type: {
      type: String,
      default: 'image'
    }
  },
  data: () => ({

    taskComments: [],
    taskcomment: { comment: '', taskMasterId: null, addedByUser: '', commentedDate: new Date(), taskCommentID: -1, documentID: null },
    subcomment: { comment: '', taskMasterId: null, addedByUser: '', commentedDate: new Date(), taskCommentID: -1, documentID: null },
    taskAccessPermission: {      assignedCc: [],
      assignedTo: null, onBehalfID: null    },
      taskMeeting: {  taskMeetingNoteID: null,taskAttachmentId: null, addedByUser: '', meetingNotes: '', addedByUserID: null , addedDate: new Date().toISOString().substr(0, 10) },
    commentloader: false,
     meetingNotesLoader: false,
    fileloader: false,
    subdialog: false,
    taskItems: [],
    mainItem: [],
    subItem: [],
    userGroupItems: [],   
    items: [],
    taskItemLink: [],
    taskMeetingNote: [],
    allFiles: [],
    uploadedFiles: [],
    showDownLoad: false,
    subtagItems: [],
    subprojectItems: [],
    subuserItems: [],
    subitems: [],
    subtaskItems: [],
    subtaskItemLink: [],
    suballFiles: [],
    subuploadedFiles: [],
    conversationDialouge: false,
    viewDialouge: false,
    setAccessDialouge: false,

    taskID: -1,
    userItems: [],
    cCItems: [],
    editorText: 'This is initialValue.',
    editorOptions: {
      hideModeSwitch: true
    },
    editorHtml: '',
    editorVisible: true,
    rightDrawer: false,
    MeetingNotesDrawer: false,
    headers: [
      { text: '', value: 'attachment', align: 'center', sortable: false, width: "1%" },
      { text: 'File Name', value: 'fileName', sortable: false, align: 'left', width: "30%" },
      { text: 'File Size(kb)', value: 'fileSize', sortable: false, align: 'left', width: "10%" },

      { text: 'File Discussion SubTask', value: '', sortable: false, align: 'left', width: "1%" },
      { text: 'Meeting Notes', value: '', sortable: false, align: 'left', width: "15%" },
      { text: 'Discussion notes', value: 'nooverdue', sortable: false, align: 'left', width: "1%" },
      { text: 'Upload Date / Modified Date', value: 'uploadDate', sortable: false, align: 'left', width: "10%" },
      { text: 'Upload By', value: 'addedByUser', sortable: false, align: 'left', width: "10%" },
      { text: 'Actions', value: 'actions', sortable: false, align: 'center' }
    ],
    items: [
      {
        icon: 'message',
        href: '#',
        title: 'Conversation',
        click: e => {
          this.$vuetify.goTo(0);
          this.rightDrawer = !this.rightDrawer;
        }
      },
       {
        icon: 'message',
        href: '#',
        title: 'Meeting Notes',
        click: e => {
          this.$vuetify.goTo(0);
          this.MeetingNotesDrawer = !this.MeetingNotesDrawer;
        }
      },
      {
        icon: 'account_circle',
        href: '#',
        title: 'Set Access',
        click: e => {
          this.setAccessDialouge = true;
        },
      },
      {
        icon: 'pageview',
        href: '#',
        title: 'View',
        click: e => {

        }
      },
      {
        icon: 'delete',
        href: '#',
        title: 'Delete',
        click: e => {

        }
      },
      {
        icon: 'cloud_download',
        href: '#',
        title: 'CheckOut',
        click: e => {
          this.download();
        }
      },
      {
        icon: 'attachment',
        href: '#',
        title: 'CheckIn',
        click: e => {
          this.download();
        }
      },

    ],
    conversationitems: [
      {
        icon: 'edit',
        href: '#',
        title: 'Edit',
        click: e => {


        }
      },
      {
        icon: 'delete',
        href: '#',
        title: 'Delete',
        click: e => {
          //  this.deleteComment(e);
        }
      },
      {
        icon: 'tune',
        href: '#',
        title: 'Convert As Task',
        click: e => {

        }
      },
      {
        icon: 'tune',
        href: '#',
        title: 'Convert As Subtask',
        click: e => {

        }
      },
      ],
       meetingitems: [
      {
        icon: 'edit',
        href: '#',
        title: 'Edit',
        click: e => {


        }
      },
      {
        icon: 'delete',
        href: '#',
        title: 'Delete',
        click: e => {
          //  this.deleteComment(e);
        }
      }
     
    ],
    formdata: {
      valid: false,
      formTitle: '',
      taskID: -1,
      date: new Date().toISOString().substr(0, 10),
      title: '',
      assignedTo: null,
      dueDate: new Date().toISOString().substr(0, 10),
      description: '',
      projectID: null,
      assignedCC: [],
      assignedRights: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date().toISOString().substr(0, 10),
      addedByUser: 'Arun',
      statusCodeID: 511,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date().toISOString().substr(0, 10),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
     
      documentID: -1,
     
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isTemp: true,
      description: '',
      uploadedFile: null,
      onBehalfName: '',
      
      overDueAllowed: 'false',
      followUp: 'false',
    },
    defaultData: {
      valid: false,
      taskID: -1,
      date: new Date().toISOString().substr(0, 10),
      title: '',
      assignedTo: null,
      dueDate: new Date().toISOString().substr(0, 10),
      description: '',
      projectID: null,
      assignedCC: [],
      onBehalfID: null,
      sessionID: '',
      taskMeetingNoteID: null,
      addedByUserID: 1,
      addedDate: new Date().toISOString().substr(0, 10),
      addedByUser: 'Arun',
      statusCodeID: 511,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date().toISOString().substr(0, 10),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
     
      documentID: -1,
      taskAttachmentId: null,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isTemp: true,
      description: '',
      uploadedFile: null,
      onBehalfName: '',
      meetingNotes: '',
      overDueAllowed: 'false',
      followUp: 'false',
    },
   
    height: {
      type: String,
      default: null,
    },
    userId: -1,
    mainTaskId: null,
  }),

  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      };
    },
    sendKey () {

      return {
        // bind to hotkey 
        'enter': this.sendFileComment,
       
      }
    },
     sendNotesKey () {

      return {
        // bind to hotkey 
        'enter': this.sendMeetingNotes,
       
      }
    },
    sendsubKey () {

      return {
        // bind to hotkey 
        'ctrl+enter': this.sendFileSubComment
      }
    },

  },
  watch: {
    subdialog (val) {
      val || this.closeDial();
    },
  },
  created () {
    
    window.getApp.$on('INITIALIZE_TASKFILE', task => {
      this.taskID = task.taskID;
      this.mainTaskId = task.mainTaskId;
      this.formdata.taskAttachmentId = task.taskAttachmentId;
      //this.formdata.attachmentIds = task.attachmentIds;
      this.initialize();
      this.uploadedFiles = [];
    });
    //  window.getApp.$on('SEND_TASKOBJ', objTask => {
    //   this.formdata = objTask;
    //   console.log(this.formdata);
    // });
    // this.$eventHub.$on('INITIALIZE_TASKCONVER', taskID => {
    //   this.taskID = taskID;
    //   this.initialize();
    // });

    // window.getApp.$on('SAVE_TASK', () => {
    //   this.save();
    // });
    this.userId = this.$store.state.auth.userId;
  },

  methods: {
    menuClick (key, item) {
      if (key == 0) {
        this.rightDrawer = !this.rightDrawer;
        this.commentloader = true;
        this.taskcomment.documentID = item.documentID;
        this.subcomment.documentID = item.documentID;
        getDocComment(item.documentID)
          .then(response => {
            this.taskComments = response.data;
            console.log(this.taskComments);
            this.commentloader = false;

          })
          .catch(error => {
            this.commentloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
         


      }
      else if (key == 1) {
         this.MeetingNotesDrawer = !this.MeetingNotesDrawer;
        this.meetingNotesLoader = true;
        //this.taskMeeting.attachmentIds = item.attachmentIds;
        this.taskMeeting.taskAttachmentId = item.taskAttachmentId;
        this.taskMeeting.addedByUserID = this.$store.state.auth.userId;
        // console.log(this.$store.state.auth.userId)
        // console.log(this.formdata.attachmentIds);
        // console.log(item.attachmentIds);
        // console.log(this.taskAttachmentId);
        // console.log(this.formdata.taskAttachmentId);
        console.log(this.taskMeeting);
        getTaskMeetingNote(this.taskMeeting)
          .then(response => {
            
            this.taskMeetingNote = response.data;
            console.log(this.taskMeetingNote);
            this.meetingNotesLoader = false;

          })
          .catch(error => {
            this.meetingNotesLoader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
        

      }
       else if (key == 2) {
        this.setAccessDialouge = true;
        this.fileloader = true;   
       console.log(this.formdata);
         this.taskAccessPermission.assignedCc = this.formdata.assignedCC;
        this.taskAccessPermission.assignedTo = this.formdata.assignedTo;
        this.taskAccessPermission.onBehalfID = this.formdata.onBehalfID;
        console.log(this.taskAccessPermission);
        getUsers(this.taskAccessPermission)
          .then(response2 => {
            console.log(response2.data);
            this.cCItems = response2.data;

            this.loader = false;

          })
          .catch(error => {
            this.loader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
        

      }
      else if (key == 3) {
        //this.viewDialouge = true;
      }
      else if (key == 4) {
        this.deleteDoc(item);
      }
      else {
        this.download(item);
      }
    },
    fileChanged (file) {

      this.uploadedFiles.push(file);
      this.showdownload = false;
      this.loader = true;
      this.subtaskfiles.append("file", file, file.name);
      uploadDocuments(this.subtaskfiles)
        .then(response => {
          this.formdata.sessionID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    removeFile (key) {
      this.uploadedFiles.splice(key, 1);
    },
    isImage (file) {
      return this.imageMime.includes(file.fileType);
    },
    mimeIcons (file) {
      return this.imageMime.includes(file.fileType)
        ? 'image'
        : 'insert_drive_file';
    },
    showDetail (file) {
      //this.editedIndex = this.documents.indexOf(file);
      //  this.editedItem = Object.assign({}, file);

      documentUsers(this.editedItem.documentID)
        .then(response => {
          //this.editedItem.userID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      this.uploadFile = true;
    },
    maincomment (key, item, mainItem) {
      this.mainItem = mainItem;
      this.subItem = item;
      if (key == 0) {
        if (item.parentCommentId == null) {
          this.taskcomment.comment = item.comment;
          this.taskcomment.taskCommentID = item.taskCommentID;
          //this.updateComment();
        }
        else {
          this.subcomment.comment = item.comment;
          this.subcomment.taskCommentID = item.taskCommentID;
          // this.updatesubComment();
        }
      }
      if (key == 1) {
        this.deleteComment(item, mainItem);
      }
      if (key == 2) {
        this.subdialog = true;
        this.formdata.formTitle = "Task"
        this.formdata.description = item.comment
        this.formdata.addedByUserID = this.$store.state.auth.userId;
        this.$refs.refsubTaskForm.formdata = this.formdata;
      }
      if (key == 3) {
        // this.editSubTask(item);
        this.subdialog = true;
        this.formdata.formTitle = "Sub Task"
        this.formdata.description = item.comment;
        this.formdata.parentTaskID = this.taskID;
        this.formdata.addedByUserID = this.$store.state.auth.userId;
        this.$refs.refsubTaskForm.parentTaskID = this.taskID;
        this.$refs.refsubTaskForm.formdata = this.formdata;
      }
    },
    //  mainSubcomment (key, item, mainItem) {
    //   this.mainItem = mainItem;
    //   this.subItem = item;
    //   if (key == 0) {
    //     if (item.parentCommentId == null) {
    //       this.taskcomment.comment = item.comment;
    //       this.taskcomment.taskCommentID = item.taskCommentID;
    //       //this.updateComment();
    //     }
    //     else {
    //       this.subcomment.comment = item.comment;
    //       this.subcomment.taskCommentID = item.taskCommentID;
    //       // this.updatesubComment();
    //     }
    //   }
    //   if (key == 1) {
    //     this.deleteComment(item, mainItem);
    //   }
    //   if (key == 2) {
    //     this.taskmodel = true;
    //     this.task.description = item.comment
    //     this.task.addedByUserID = this.$store.state.auth.userId;
    //   }
    //   if (key == 3) {
    //     this.taskmodel = true;
    //     this.task.description = item.comment;
    //     this.task.parentTaskID = this.taskID;
    //     this.task.addedByUserID = this.$store.state.auth.userId;
    //   }
    // },
    downloadFile (key) {

      this.loader = true;
      downloadFile(this.formdata.attachments[key])
        .then(response => {
          let blob = new Blob([response.data], { type: this.editFile.contentType })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.editFile.name
          link.click()
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    getAttachments () {
      getTaskAttachment(this.formdata.taskID)
        .then(response => {

          this.editFile.name = response.data[0].fileName;
          this.editFile.contentType = response.data[0].contentType;
          this.editFile.size = response.data[0].fileSize;
          this.showdownload = true;

          this.uploadedFiles.push(this.editFile);
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    sendFileComment (item) {
       if (this.taskcomment.comment.trim().length > 0) {
        this.commentloader = true;

        this.taskcomment.taskMasterId = this.taskID;
        this.taskcomment.commentedBy = this.$store.state.auth.userId;
        this.taskcomment.addedByUser = this.$store.state.auth.userName;
        this.taskcomment.commentedDate = new Date();
        if (this.taskcomment.taskCommentID > 0) {
          this.updateComment();
        }
        else {
          createTaskComments(this.taskcomment)
            .then(response => {

              this.taskComments.push(response.data);
              this.taskcomment.comment = '';
              this.commentloader = false;
            })
            .catch(error => {
              this.commentloader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
      }

    },
     sendMeetingNotes (item) {
      if (this.taskMeeting.meetingNotes.trim().length > 0) {
        this.meetingNotesLoader = true;

      // this.taskMeeting.taskAttachmentId = item.taskAttachmentId;
        this.taskMeeting.addedByUserID = this.$store.state.auth.userId;
        this.taskMeeting.addedByUser = this.$store.state.auth.userName;
       // this.taskMeeting.attachmentIds = item.attachmentIds;
        this.taskMeeting.addedDate = new Date();
      //   console.log(item);
      //  console.log(this.taskMeeting);
        if (this.taskMeeting.taskMeetingNoteID > 0) {
          this.updateMeetingNotes(item);

        }
        else
        {
       
          createTaskMeetingNote(this.taskMeeting)
            .then(response => {

              this.taskMeeting=response.data;
              this.taskMeeting.meetingNotes = '';
              this.meetingNotesLoader = false;
            })
            .catch(error => {
              this.meetingNotesLoader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
      }

    },
    sendFileSubComment (mainComment) {
      if (this.subcomment.comment.trim().length > 0) {
        this.commentloader = true;
        this.subcomment.taskMasterId = this.taskID;
        this.subcomment.parentCommentId = mainComment.taskCommentID;
        this.subcomment.commentedBy = this.$store.state.auth.userId;
        this.subcomment.addedByUser = this.$store.state.auth.userName;
        this.subcomment.commentedDate = new Date();
        if (this.subcomment.taskCommentID > 0) {
          this.updatesubComment(mainComment);

        }
        else {
          createTaskComments(this.subcomment)
            .then(response => {
              mainComment.taskCommentModels.push(response.data);

              //this.taskComments.push(response.data);
              this.subcomment.comment = '';
              this.commentloader = false;
            })
            .catch(error => {
              this.commentloader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
      }

    },

    initialize () {
      this.uploadedFiles = [];
      this.fileloader = true;
      if (this.taskID > 0) {
        getTaskFiles(this.taskID)
          .then(response => {
            this.taskItems = response.data;
            this.fileloader = false;
          })
          .catch(error => {
            this.fileloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });


      }
      else {
        this.taskItems = [];
        this.fileloader = false;
      }
     



    },

    updateComment () {

      if (this.taskcomment.comment.trim().length > 0) {
        this.commentloader = true;

        // this.taskcomment.taskMasterId = this.taskID;
        // this.taskcomment.commentedBy = this.$store.state.auth.userId;
        // this.taskcomment.addedByUser = this.$store.state.auth.userName;
        // this.taskcomment.commentedDate = new Date();

        updateTaskComment(this.taskcomment)
          .then(response => {
            this.mainItem.comment = this.taskcomment.comment;
            this.mainItem.isEdited = true;
            this.taskcomment.taskCommentID = -1;
            this.taskcomment.comment = '';
            this.commentloader = false;
          })
          .catch(error => {
            this.commentloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
      }
    },
    updatesubComment (mainComment) {

      if (this.subcomment.comment.trim().length > 0) {
        this.commentloader = true;

        // this.taskcomment.taskMasterId = this.taskID;
        // this.taskcomment.commentedBy = this.$store.state.auth.userId;
        // this.taskcomment.addedByUser = this.$store.state.auth.userName;
        // this.taskcomment.commentedDate = new Date();

        updateTaskComment(this.subcomment)
          .then(response => {
            this.subItem.comment = this.subcomment.comment;
            this.subItem.isEdited = true;
            this.subcomment.taskCommentID = -1;
            this.subcomment.comment = '';
            this.commentloader = false;
          })
          .catch(error => {
            this.commentloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
      }
    },
     updateMeetingNotes (item) {
     console.log(item);
      if (this.taskMeeting.meetingNotes.trim().length > 0) {
        this.meetingNotesLoader = true;
         console.log(this.taskMeeting);
        // this.taskcomment.taskMasterId = this.taskID;
        // this.taskcomment.commentedBy = this.$store.state.auth.userId;
        // this.taskcomment.addedByUser = this.$store.state.auth.userName;
        // this.taskcomment.commentedDate = new Date();

        updateTaskMeetingNote(this.taskMeeting)
          .then(response => {
            this.mainItem.meetingNotes = this.taskMeeting.meetingNotes;
            this.mainItem.isEdited = true;
            this.taskMeeting.taskMeetingNoteID = -1;
            this.taskMeeting.meetingNotes = '';
            this.meetingNotesLoader = false;
          })
          .catch(error => {
            this.meetingNotesLoader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
      }
    },
    deleteComment (item, mainItem) {

      deleteTaskComment(item)
        .then(response => {
          const index = mainItem.taskCommentModels.indexOf(item);
          mainItem.taskCommentModels.splice(index, 1);
          this.commentloader = false;
        })
        .catch(error => {
          this.commentloader = false;
          window.getApp.$emisubdialogt('APP_API_ERROR', error);
        });

    },
    save () {
      if (this.$refs.refsubTaskForm.$refs.validatesubform.validate()) {

        this.formdata = this.$refs.refsubTaskForm.formdata;
        this.loader = true;
        this.formdata.addedByUserId = this.$store.state.auth.userId;
        this.formdata.addedDate = new Date().toISOString().substr(0, 10);
        this.formdata.statusCodeID = 512;
        this.formdata.mainTaskId = this.mainTaskId;
        createTaskMaster(this.formdata)
          .then(response => {
            this.loader = false;
            this.formdata = response.data;
            window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
            this.subdialog = false;
            window.getApp.$emit('INITIALIZE_SUBTASK', this.mainTaskId);
            this.formdata = Object.assign({}, this.defaultData);
          })
          .catch(error => {
            this.loader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });

      }
      else {
        window.getApp.$emit('APP_API_VAL', GlobalMessage.VALIDATE);
      }
    },
    download (item) {
      this.fileloader = true;
      downloadFile(item.documentID)
        .then(response => {
          let blob = new Blob([response.data], { type: item.contentType })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = item.fileName
          link.click()
          this.fileloader = false;

        })
        .catch(error => {
          this.fileloader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    deleteDoc (item) {
      let index = this.taskItems.indexOf(item);
      deleteDocuments(item)
        .then(response => {
          this.taskItems.splice(index, 1);

        })
        .catch(error => {
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    formateDate (string) {
      return string ? new Date(string).toLocaleDateString() : '';
    },

    closeDial () {
      this.formdata = Object.assign({}, this.defaultData);
    }
  }
};
</script>

<style lang="stylus" scoped>
.color-option {
  &--label {
    position: relative;
    display: block;
    cursor: pointer;

    & input[type='radio'] {
      display: none;

      &+span {
        position: relative;

        &>.overlay {
          display: none;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.3);
          text-align: center;
          line-height: 30px;
          color: #fff;
        }
      }

      &:checked+span>.overlay {
        display: block;
      }
    }

    & .bg {
      background-color: #f1f1f1;
    }
  }

  &--item {
    overflow: hidden;
    display: block;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;

    &--header {
      height: 10px;
    }

    &>span {
      display: block;
      float: left;
      width: 50%;
      height: 20px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/task/FileList.vue